import * as React from "react";
import type { SVGProps } from "react";
const SvgWirelessInternetIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M15.395 1.955a.56.56 0 0 0-.39.961 6.157 6.157 0 0 1 0 8.728.56.56 0 1 0 .79.792 7.295 7.295 0 0 0 0-10.312.56.56 0 0 0-.4-.17m-1.569 1.567a.56.56 0 0 0-.39.962 3.93 3.93 0 0 1 0 5.536.561.561 0 1 0 .791.792c1.954-1.953 1.954-5.166 0-7.12a.56.56 0 0 0-.4-.17m-1.624 1.624a.56.56 0 0 0-.39.962c.69.69.69 1.71 0 2.4a.558.558 0 0 0 .177.923.56.56 0 0 0 .615-.13 2.814 2.814 0 0 0 0-3.985.56.56 0 0 0-.402-.17m-6.61 1.566a.56.56 0 0 0-.552.568v11.76H3.92c-.921 0-1.68.759-1.68 1.68v3.36c0 .922.759 1.68 1.68 1.68h20.16c.921 0 1.68-.759 1.68-1.68v-3.36c0-.921-.759-1.68-1.68-1.68H10.64V7.28a.561.561 0 1 0-1.12 0v11.76H6.16V7.28a.56.56 0 0 0-.569-.568M3.92 20.16h1.586q.09.015.183 0h4.297q.09.015.183 0H24.08c.31 0 .56.25.56.56v3.36c0 .31-.25.56-.56.56H3.92c-.31 0-.56-.25-.56-.56v-3.36c0-.31.25-.56.56-.56m1.68 1.68c-.336 0-.56.224-.56.56s.224.56.56.56.56-.224.56-.56-.224-.56-.56-.56m2.24 0c-.336 0-.56.224-.56.56s.224.56.56.56.56-.224.56-.56-.224-.56-.56-.56m2.24 0c-.336 0-.56.224-.56.56s.224.56.56.56.56-.224.56-.56-.224-.56-.56-.56m2.24 0c-.336 0-.56.224-.56.56s.224.56.56.56.56-.224.56-.56-.224-.56-.56-.56m2.24 0c-.336 0-.56.224-.56.56s.224.56.56.56.56-.224.56-.56-.224-.56-.56-.56"
    />
  </svg>
);
export default SvgWirelessInternetIcon;
